import {BDShareholder} from "@/store/api/bdShareholderApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {BDShareholderFormDataType} from "@/component/blocks/BDShareholderForm";

interface BDShareholderFormData {
    complete: boolean;
    data: BDShareholderFormDataType | null;
}

interface BDShareholderState {
    bdShareholderFormData: BDShareholderFormData[];
    bdShareholders: BDShareholder[] | null;
}

const initialState: BDShareholderState = {
    bdShareholders: null,
    bdShareholderFormData: [{complete: false, data: null}]
}

const bdShareholderSlice = createSlice({
    name: "bdShareholder",
    initialState,
    reducers: {
        addBDShareholder: (state) => {
            state.bdShareholderFormData.push({complete: false, data: null});
        },
        deleteBDShareholder: (state, action) => {
            state.bdShareholderFormData.splice(state.bdShareholderFormData.length, 1);
        },
        saveBDShareholder: (state, action) => {
            const index = action.payload.index;
            const data = action.payload.data;
            state.bdShareholderFormData[index] = {complete: true, data: data};
        },
        updateBDShareholder: (state, action) => {
            const index = action.payload;
            if (state.bdShareholderFormData[index]) {
                state.bdShareholderFormData[index].complete = false;
            }
        },
        setBDShareholder: (state, action: PayloadAction<BDShareholder[]>) => {
            state.bdShareholders = action.payload;
        }
    }
})

export const {addBDShareholder, deleteBDShareholder, saveBDShareholder, updateBDShareholder, setBDShareholder} = bdShareholderSlice.actions;
export default bdShareholderSlice.reducer;